import {
  ACTION_GET_SINGLE_HOTEL,
  ACTION_GET_SINGLE_HOTEL_SUCCESS,
  ACTION_GET_SINGLE_HOTEL_FAILURE,
  API_CALL,
} from '../../../configs/ActionTypes';
import { Dispatch } from 'redux';
import { enqueueSnackbarHandler } from '../../Status';

export type HotelMappingEntry = {
  hotelId?: string;
  result?: unknown;
  message?: string;
};

export type LookupHotelByIdPayload = {
  rapidId?: string;
  travelportId?: string;
};

export type LookupHotelByIdResponse = {
  mapping?: unknown;
  expediaInfo?: HotelMappingEntry[] | null;
  travelportInfo?: HotelMappingEntry[] | null;
  raw?: unknown;
};

const getErrorMessage = (error: any): string => {
  const payload = error?.payload;
  if (typeof payload?.message === 'string' && payload.message.trim()) {
    return payload.message;
  }
  if (typeof payload === 'string' && payload.trim()) {
    return payload;
  }
  return 'An unexpected error occurred.';
};

const normalizeLookupResponse = (response: any): LookupHotelByIdResponse => {
  const payload = response?.payload?.payload ?? response?.payload ?? response ?? {};
  const hotelMapping = payload?.hotelMapping ?? {};

  return {
    mapping: payload?.mapping ?? null,
    expediaInfo: Array.isArray(hotelMapping?.rapidId) ? hotelMapping.rapidId : null,
    travelportInfo: Array.isArray(hotelMapping?.travelportId) ? hotelMapping.travelportId : null,
    raw: payload,
  };
};

export function lookupHotelById(
  data: LookupHotelByIdPayload,
  onSuccess: (result: LookupHotelByIdResponse) => void,
  onError: (message: string) => void,
  onSettled: () => void,
) {
  return (dispatch: Dispatch) => {
    dispatch({ type: ACTION_GET_SINGLE_HOTEL, payload: null });

    dispatch({
      type: API_CALL,
      payload: {
        call: 'search-hotel-by-id',
        method: 'get',
        data,
        success: (response: any) => {
          if (response?.type === 'error') {
            enqueueSnackbarHandler(dispatch, response?.payload, 'error');
            const message = getErrorMessage(response);
            onError(message);
            dispatch({ type: ACTION_GET_SINGLE_HOTEL_FAILURE, payload: response });
            onSettled();
            return;
          }

          onSuccess(normalizeLookupResponse(response));
          dispatch({ type: ACTION_GET_SINGLE_HOTEL_SUCCESS, payload: response });
          onSettled();
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error?.payload, 'error');
          const message = getErrorMessage(error);
          onError(message);
          dispatch({ type: ACTION_GET_SINGLE_HOTEL_FAILURE, payload: error });
          onSettled();
        },
      },
    });
  };
}
